export default __webpack_public_path__ + "static/media/orange.cd4b36bc.gif";